












import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import PageBase from './PageBase'
import PageForm from '@/components/PageForm.vue'
import { Page } from '@/models/Page'

@Component({
	components: {
		PageForm,
	},
})
export default class EditPage extends PageBase {
	private currentPage: number = NaN

	@Watch('$route.params.id', { immediate: true })
	private onNameChange(val: string) {
		this.currentPage = parseInt(val, 10)
	}

	get page() {
		return this.$store.getters.currentPage(this.currentPage)
	}

	private submit(page: Page) {
		this.$store.dispatch('savePage', page)
			.then(() => this.$toasted.success('Page successfully updated.'),
			(error: any) => {
				this.$toasted.error(`Error: ${page.errorArray}`)
				this.page.reset()
			})
	}
}
